import { useTranslation } from "react-i18next";
import type { AppLocale } from "./constants";

export function useLocale(): AppLocale {
  const { i18n } = useTranslation();
  return i18n.language === "en" ? "en" : "es";
}
